export const capitalizeOnlyFirstLetter = (t: string) => {
  return t.charAt(0).toUpperCase() + t.slice(1).toLowerCase();
}
